import React from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";

export default styled<any>(Button)<any>`
  padding: 10px 20px;
  background-color: ${(props) => props.theme.colors.orange};
  color: white;
  font-weight: 600;
  :hover {
    background-color: rgb(186 50 48);
  }
`;
